import NotFoundTracker from "../components/NotFoundTracker";
import { useMetaTags } from "../components/MetaTags";

export function NotFound() {
  // Without this the 404 inherited the template's default <head>, so an
  // unknown URL served the home page's title and canonical — a soft 404 that
  // invited Google to index it as a duplicate of the home page.
  useMetaTags({
    title: "Page not found | OmniCanvas",
    description: "The page you're looking for doesn't exist or has been moved.",
    // Without an explicit url this defaults to the site root, so every 404 told
    // crawlers its canonical *was* the home page — the same soft-404 signal in
    // a second place.
    url: "https://omnicanvasnotes.com/404",
    robots: "noindex, follow",
  });

  return (
    <div className="pt-28 pb-20">
      <NotFoundTracker />
      <div className="max-w-xl mx-auto px-6 text-center">
        <h1 className="text-7xl font-extrabold text-indigo-600 mb-4">404</h1>
        <h2 className="text-2xl font-bold text-slate-900 mb-4">Page not found</h2>
        <p className="text-slate-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <a
          href="/"
          className="inline-block bg-indigo-600 text-white font-semibold text-sm px-6 py-3 rounded-xl hover:bg-indigo-700 transition-colors"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
}
